import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/templateSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { Link } from "react-router-dom";
import { fetchTemplatesListPage } from "slices/templateSlice";
import { templatesSelector } from "slices/templateSlice";
import { removeMultipleTemplates } from "slices/templateSlice";
import { usePermissions } from "layouts/Admin";
import { useTranslation } from "react-i18next";
const apiService = new Api();

function ClientTemplates() {
  const dispatch = useDispatch()
  const { t } = useTranslation();

  const { templatesListPage, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(templatesSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });
  const { checkPermission } = usePermissions()
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'desc',
  });

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchTemplatesListPage(page));
  }, [])
  React.useEffect(() => {
    dispatch(fetchTemplatesListPage())
  }, [])

  const handleAddAccountPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchTemplatesListPage())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleRemoveItems = React.useCallback(() => {
    dispatch(removeMultipleTemplates({ ids: selectedItems }, submitCallback))
  }, [selectedItems])

  const handleChange = (e) => {
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(templatesListPage.map((template) => template.id.toString()))
  }



  const renderTableHeader = React.useCallback(() => {



    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchTemplatesListPage(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Client Template') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th>

          <TableHeaderItem
            title={t("translation.templateName")}
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title={t("translation.lastUpdatedDate")}
            sortBy="updated_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Client Template') &&
          <th >{t("table.status")}</th>
        }
        {checkPermission('Edit Client Template') &&
          <th >{t("table.action")}</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, templatesListPage])


  const renderTableContent = React.useCallback(() => {
    return (
      templatesListPage?.map((template, index) => {
        return <AccountItem data={template} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAccountPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      })
    )
  }, [templatesListPage, selectedItems, current_page]);

  const handleClose = React.useCallback(() => {
    // refAddutton.current.click();
    setAddForm({ show: false })
  }, [])


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  return (
    <ListLayout
      heading={t("translation.clientTemplates")}
      time={true}
      title=""
      buttonTitle={t("translation.createTemplate")}
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchTemplatesListPage}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddLink={() => checkPermission('Add Client Template') && <Link to="/clients/templates/create" className="main_button ml-4">{t("translation.createTemplate")}</Link>}
      addformModal={false}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddAccountPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      sortConfig={sortConfig}
      loader={loader}
      searchPlaceholder={t("translation.searchTemplates")}
      noOfItems={total}
      disableBootstrap={true}
      defaultPageLength={pageLength}
    >
      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}

const AccountItem = ({
  data, index, selectedItems, handleChange, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(data?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  React.useEffect(() => {
    setStatus(data?.status == 1 ? 1 : 0 || 0)

  }, [data])
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).replace(",", "");
  };


  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Client Template') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={data?.id} checked={selectedItems.includes(data?.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.name || "N/A"}
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.updated_at ? formatDate(data?.updated_at) : "N/A"}
      </td>
      {
        checkPermission('Status Client Template') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(data?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {
        checkPermission('Edit Client Template') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <Link to={`/clients/templates/update/${data?.id}`} className="table_edit">Edit</Link>
          </div>
        </td>
      }
    </tr >
  )
}

export default ClientTemplates;